import {
  KYC_ROUTES,
  kycResponseSchema,
  type Kyc,
  type KycDocumentInput,
  type KycReview,
} from "@nh/shared";
import { authFetch } from "@/shared/api/session";

const NO_PREFIX = { baseUrl: "" } as const;

/** El expediente propio, sin archivos. */
export async function getMyKyc(): Promise<Kyc> {
  const data = await authFetch(KYC_ROUTES.mine, kycResponseSchema, NO_PREFIX);
  return data.kyc;
}

/** Sube (o reemplaza) un documento. Devuelve el expediente ya movido. */
export async function uploadKycDocument(input: KycDocumentInput): Promise<Kyc> {
  const data = await authFetch(KYC_ROUTES.mineDocuments, kycResponseSchema, {
    ...NO_PREFIX,
    method: "POST",
    body: input,
  });
  return data.kyc;
}

/** El expediente de alguien, CON archivos (`dataUrl`). Solo panel. */
export async function getKycForAdmin(userId: string): Promise<Kyc> {
  const data = await authFetch(KYC_ROUTES.adminOne(userId), kycResponseSchema, NO_PREFIX);
  return data.kyc;
}

/** El veredicto. Rechazar exige nota (el contrato lo hace cumplir). */
export async function reviewKyc(userId: string, review: KycReview): Promise<Kyc> {
  const data = await authFetch(KYC_ROUTES.adminOne(userId), kycResponseSchema, {
    ...NO_PREFIX,
    method: "PATCH",
    body: review,
  });
  return data.kyc;
}

/** De `File` a lo que viaja: base64 sin el prefijo `data:`. El mismo
 * sobre que el comprobante de pago. */
export async function fileToBase64(file: File): Promise<string> {
  const dataUrl = await new Promise<string>((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(String(reader.result));
    reader.onerror = () => reject(new Error("No se pudo leer el archivo"));
    reader.readAsDataURL(file);
  });
  return dataUrl.slice(dataUrl.indexOf(",") + 1);
}
